import { useQuery } from '@tanstack/react-query';
import { Moment } from 'moment';
import { ErrorLogApi } from '../apis/error-log-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const ErrorLogQueries = {
  useErrorLogList: (date: Moment) =>
    useQuery({
      queryKey: ['errorLogList', date.toISOString()],
      queryFn: async () => await ErrorLogApi.getErrorLogs(date.toISOString()),
      onError: () => CloseableErrorMessage('Error getting web/app error log.'),
      staleTime: 60000,
      enabled: !!date
    }),
};
